/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Field_Stream_HintInputs */

const vi_grower_area_camera_field_stream_hint = /** @type {(inputs: Grower_Area_Camera_Field_Stream_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dán nguyên link camera được bàn giao cũng được — hệ thống tự tách lấy token.`)
};

/**

* @param {Grower_Area_Camera_Field_Stream_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_field_stream_hint = /** @type {((inputs?: Grower_Area_Camera_Field_Stream_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Field_Stream_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_field_stream_hint(inputs)
});